var ValueJS = ValueJS || {};

ValueJS.Countdown = function() {

    var _initialized = false;
    var _counters = [];
    var _intervalId  = false;

    var _init = function() {

        $('.countdown').each(function() {
            let timer = $(this);

            let deadline = new Date(timer.data('deadline')).getTime();

            _counters.push({
                timer:          timer,
                deadline:       deadline,
                daysEl:         timer.find('.countdown__days'),
                hoursEl:        timer.find('.countdown__hours'),
                minutesEl:      timer.find('.countdown__minutes'),
                secondsEl:      timer.find('.countdown__seconds'),
            });

        });

        if (_counters.length) {
            _update();
            _intervalId = setInterval(_update, 1000);
        }

        if (!_initialized) {
            _handleShopifyDesignModeEvents();
            _initialized = true;
        }

    }

    var _update = function() {

        let now = new Date().getTime();

        _counters.forEach((counter) => {
            
            let timeLeft = counter.deadline - now;

            if (timeLeft >= 0) {
                let days = 0;
                let hours = 0;
                let minutes = 0;
                let seconds = 0;
                
                // calculate
                days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
                hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
                seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

                // add prefix zero
                days = (days.toString().length === 1) ? '0' + days : days;
                hours = (hours.toString().length === 1) ? '0' + hours : hours;
                minutes = (minutes.toString().length === 1) ? '0' + minutes : minutes;
                seconds = (seconds.toString().length === 1) ? '0' + seconds : seconds;

                // update HTML
                counter.daysEl.text(days);
                counter.hoursEl.text(hours);
                counter.minutesEl.text(minutes);
                counter.secondsEl.text(seconds);
            }

        });

    }

    var _handleShopifyDesignModeEvents = function() {
        if (Shopify.designMode) {

            $(document).on('shopify:section:load', function(e) {
                if (_intervalId) {
                    clearInterval();
                }
                _init();
            });


            $(document).on('shopify:block:select', function(e) {
                if (_intervalId) {
                    clearInterval();
                }
                _init();
            });

            $(document).on('shopify:block:deselect', function(e) {
                if (_intervalId) {
                    clearInterval();
                }
                _init();
            });

        }
    }

    // var _subscriptionHandler = function(name) {
    //     return function(e, context) {
    //         _init(context);
    //     };
    // }


    /** PUBLIC API **/
    return {
        init : function() {return _init();},
        // subscriptionHandler : function(name) {return _subscriptionHandler(name);},
    };

}();

$(function() {
    ValueJS.Countdown.init();
    // $.subscribe('ValueJSSwiper.afterInit', ValueJS.Countdown.subscriptionHandler('ValueJSSwiper.afterInit'));
});
